export default __webpack_public_path__ + "static/media/activity.1e1f4a69.svg";